// extracted by mini-css-extract-plugin
export default {"wrapper":"op-z","reviewFormSuccess":"pp-z","header":"qp-z","message":"rp-z","paragraph":"sp-z","lottieContainer":"tp-z"};